import React, { useState, useEffect } from "react";
// ... existing code ...
import { Helmet } from "react-helmet";
import SectionTitle from "../common/SectionTitle";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SRLWrapper } from "simple-react-lightbox";

function ElmaliCosmosBeige() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  
  // Tüm resimleri bir array'de topla - MOVED BEFORE useState
  const allImages = [
    { src: "/assets/img/Elmalı Cosmos Beige Blocks-1.webp", title: t("Cosmos Beige Blocks") },
    { src: "/assets/img/Elmalı Cosmos Beige Slabs-1.webp", title: t("Cosmos Beige Slabs") },
    { src: "/assets/img/Elmalı Cosmos Beige Blocks-2.webp", title: t("Cosmos Beige Blocks") },
    { src: "/assets/img/Elmalı Cosmos Beige Blocks-33.webp", title: t("Cosmos Beige Blocks") },
    { src: "/assets/img/Elmalı Cosmos Beige Blocks-4.webp", title: t("Cosmos Beige Blocks") },
    { src: "/assets/img/Elmalı Cosmos Beige Blocks-5.webp", title: t("Cosmos Beige Blocks") },
    { src: "/assets/img/Elmalı Cosmos Beige Blocks-6.webp", title: t("Cosmos Beige Blocks") },
    { src: "/assets/img/Elmalı Cosmos Beige Blocks-7.webp", title: t("Cosmos Beige Blocks") },
    { src: "/assets/img/Elmalı Cosmos Beige Blocks-8.webp", title: t("Cosmos Beige Blocks") },
    { src: "/assets/img/Elmalı Cosmos Beige Slabs-2.webp", title: t("Cosmos Beige Slabs") },
    { src: "/assets/img/Elmalı Cosmos Beige Slabs-3.webp", title: t("Cosmos Beige Slabs") },
    { src: "/assets/img/Elmalı Cosmos Beige Slabs-4.webp", title: t("Cosmos Beige Slabs") },
    { src: "/assets/img/Elmalı Cosmos Beige Slabs-5.webp", title: t("Cosmos Beige Slabs") },
    { src: "/assets/img/Elmalı Cosmos Beige Slabs-6.webp", title: t("Cosmos Beige Slabs") },
    { src: "/assets/img/Elmalı Cosmos Beige Slabs-7.webp", title: t("Cosmos Beige Slabs") },
    { src: "/assets/img/Elmalı Cosmos Beige Slabs-8.webp", title: t("Cosmos Beige Slabs") }
  ];
  
  const [showAllImages, setShowAllImages] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0); // Changed to use index 0 instead of allImages[0]

  // İlk resmi preload et
  useEffect(() => {
    if (allImages.length > 0) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = allImages[0].src;
      document.head.appendChild(link);
    }
  }, []); // Changed to use index 0 instead of allImages[0]

  // scrollToTop fonksiyonunu ekleyin
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const options = {
    settings: {
      overlayColor: "rgba(0, 0, 0, 0.8)",
      autoplaySpeed: 3000,
      transitionSpeed: 900,
    },
    buttons: {
      backgroundColor: "rgba(30,30,36,0.8)",
      iconColor: "rgba(255, 255, 255, 0.8)",
    },
    caption: {
      captionColor: "#FFFFFF",
      captionFontFamily: "inherit",
      captionFontSize: "inherit",
      captionTextTransform: "inherit"
    }
  };

  return (
    <>
      <Helmet>
        <title>{currentLang === 'tr' ? 'Cosmos Bej Mermer - MOCA Mermer | Antalya Elmalı Premium Doğal Taş' : 'Cosmos Beige Marble - MOCA Marble | Antalya Elmali Premium Natural Stone'}</title>
        <meta name="description" content={currentLang === 'tr' ? 'Antalya Elmalı ocaklarından çıkarılan Cosmos Bej mermer. Premium kalitede bej tonları, blok ve plaka formatında. İç-dış mekân uygulamaları için ideal doğal taş çözümü.' : 'Cosmos Beige marble extracted from Antalya Elmali quarries. Premium quality beige tones, available in blocks and slabs. Ideal natural stone solution for indoor-outdoor applications.'} />
        <meta name="keywords" content={currentLang === 'tr' ? 'cosmos bej mermer, antalya elmalı cosmos, bej mermer, cosmos mermer blok, cosmos mermer plaka, doğal taş' : 'cosmos beige marble, antalya elmali cosmos, beige marble, cosmos marble blocks, cosmos marble slabs, natural stone'} />
        <link rel="canonical" href="https://mocamermer.com/elmalicosmosbeige" />
        <meta property="og:title" content={currentLang === 'tr' ? 'Cosmos Bej Mermer | Antalya Elmalı Premium Doğal Taş - MOCA Mermer' : 'Cosmos Beige Marble | Antalya Elmali Premium Natural Stone - MOCA Marble'} />
        <meta property="og:description" content={currentLang === 'tr' ? 'Antalya Elmalı\'dan çıkarılan Cosmos Bej mermer ile projelerinize değer katın. Blok ve plaka formatında, premium kalitede doğal taş çözümleri.' : 'Add value to your projects with Cosmos Beige marble extracted from Antalya Elmali. Premium quality natural stone solutions in blocks and slabs.'} />
        <meta property="og:image" content="https://mocamermer.com/assets/img/Cosmos-Beige.webp" />
        <meta property="og:url" content="https://mocamermer.com/elmalicosmosbeige" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": currentLang === 'tr' ? "Cosmos Bej Mermer" : "Cosmos Beige Marble",
            "description": currentLang === 'tr' ? "Antalya Elmalı ocaklarından çıkarılan premium kalitede Cosmos Bej mermer" : "Premium quality Cosmos Beige marble extracted from Antalya Elmali quarries",
            "brand": "MOCA Mermer",
            "category": currentLang === 'tr' ? "Doğal Taş" : "Natural Stone",
            "material": currentLang === 'tr' ? "Mermer" : "Marble",
            "color": currentLang === 'tr' ? "Bej" : "Beige",
            "origin": "Antalya Elmalı, Turkey",
            "image": "https://mocamermer.com/assets/img/Cosmos-Beige.webp",
            "manufacturer": {
              "@type": "Organization",
              "name": "MOCA Mermer",
              "url": "https://mocamermer.com"
            }
          })}
        </script>
      </Helmet>
      
      <section
        className="ocaklarimiz"
        style={{ marginTop: "7rem"}}
        id="elmalicosmosbeige"
      >
        <div className="container">
          {/* Header Section */}
          <div className="text-center mb-5">
            <SectionTitle title={t("COSMOS BEIGE")} />
            <p className="lead text-muted mb-4">
              {t("Cosmos Beige Description")}
            </p>
          </div>

          {/* Main Content */}
          <div className="row g-5">
            {/* Image Gallery */}
            <div className="col-lg-7">
              <div className="bg-white rounded-4 shadow-sm p-4">
                <SRLWrapper options={options}>
                  {/* Main Image */}
                  <div className="mb-4">
                    <div className="position-relative overflow-hidden rounded-3">
                      <img 
                        src={allImages[selectedImage].src}
                        alt={allImages[selectedImage].title}
                         className="img-fluid w-100"
                            loading="lazy"
                        style={{height: '400px', objectFit: 'cover', cursor: 'pointer'}}
                        data-attribute="SRL"
                      />
                      <div className="position-absolute top-0 end-0 m-3">
                        <span className="badge bg-dark bg-opacity-75 px-3 py-2">
                          <i className="fas fa-expand-alt me-1"></i>
                          {t("Click to Enlarge")}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Thumbnail Grid */}
                  <div className="row g-2">
                    {allImages.slice(0, showAllImages ? allImages.length : 4).map((img, index) => (
                      <div className="col-3" key={index}>
                        <div 
                          className={`position-relative overflow-hidden rounded-2 cursor-pointer border ${
                            selectedImage === index ? 'border-3' : 'border-1'
                          }`}
                          style={{
                            borderColor: selectedImage === index ? '#a79682' : '#dee2e6',
                            transition: 'all 0.3s ease'
                          }}
                          onClick={() => setSelectedImage(index)}
                        >
                          <img 
                            src={img.src}
                            alt={img.title}
                             className="img-fluid w-100"
                            loading="lazy"
                            style={{
                              height: '70px', 
                              objectFit: 'cover',
                              opacity: selectedImage === index ? 1 : 0.8,
                              transition: 'opacity 0.3s ease'
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  {/* Show More Button */}
                  {allImages.length > 4 && (
                    <div className="text-center mt-3">
                      <button 
                        className="btn btn-outline-secondary btn-sm rounded-pill px-4"
                        onClick={() => setShowAllImages(!showAllImages)}
                      >
                        <i className={`fas ${showAllImages ? 'fa-minus' : 'fa-plus'} me-1`}></i>
                        {showAllImages 
                          ? t("Show Less Images") 
                          : `${t("Show More Images")} (${allImages.length - 4})`
                        }
                      </button>
                    </div>
                  )}
                </SRLWrapper>
              </div>
            </div>

            {/* Product Information */}
            <div className="col-lg-5">
              <div className="bg-white rounded-4 shadow-sm p-4 h-100">
                {/* Product Title */}
                <div className="mb-4">
                  <h1 className="h3 fw-bold mb-2" style={{color: '#a79682'}}>
                    <i className="fas fa-gem me-2"></i>
                    {t("Cosmos Beige")}
                  </h1>
                  <div className="d-flex align-items-center text-muted">
                    <i className="fas fa-map-marker-alt me-2"></i>
                    <span>{t("Antalya Elmalı, Turkey")}</span>
                  </div>
                </div>

                {/* Product Features */}
                <div className="mb-4">
                  <h5 className="fw-bold mb-3" style={{color: '#333'}}>
                    <i className="fas fa-list-check me-2" style={{color: '#a79682'}}></i>
                    {t("Cosmos Beige Features")}
                  </h5>
                  
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="d-flex align-items-center p-3 rounded-3 border-start border-4" 
                           style={{backgroundColor: '#f8f9fa', borderColor: '#a79682'}}>
                        <div className="me-3">
                          <i className="fas fa-palette" style={{color: '#a79682', fontSize: '1.2rem'}}></i>
                        </div>
                        <div>
                          <h6 className="mb-1 fw-semibold">{t("Color")}</h6>
                          <small className="text-muted">{t("Cosmos Beige Color")}</small>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-12">
                      <div className="d-flex align-items-center p-3 rounded-3 border-start border-4" 
                           style={{backgroundColor: '#f8f9fa', borderColor: '#6c757d'}}>
                        <div className="me-3">
                          <i className="fas fa-weight-hanging" style={{color: '#6c757d', fontSize: '1.2rem'}}></i>
                        </div>
                        <div>
                          <h6 className="mb-1 fw-semibold">{t("Density")}</h6>
                          <small className="text-muted">{t("Cosmos Beige Density")}</small>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-12">
                      <div className="d-flex align-items-center p-3 rounded-3 border-start border-4" 
                           style={{backgroundColor: '#f8f9fa', borderColor: '#a79682'}}>
                        <div className="me-3">
                          <i className="fas fa-hammer" style={{color: '#a79682', fontSize: '1.2rem'}}></i>
                        </div>
                        <div>
                          <h6 className="mb-1 fw-semibold">{t("Hardness")}</h6>
                          <small className="text-muted">{t("Cosmos Beige Hardness")}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Applications */}
                <div className="mb-4">
                  <h5 className="fw-bold mb-3" style={{color: '#333'}}>
                    <i className="fas fa-tools me-2" style={{color: '#a79682'}}></i>
                    {t("Cosmos Beige Applications")}
                  </h5>
                  <p className="text-muted mb-3">{t("Cosmos Beige Applications Description")}</p>
                  
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="d-flex align-items-center p-3 rounded-3 border-start border-4" 
                           style={{backgroundColor: '#f8f9fa', borderColor: '#a79682'}}>
                        <div className="me-3">
                          <i className="fas fa-home" style={{color: '#a79682', fontSize: '1.2rem'}}></i>
                        </div>
                        <div>
                          <h6 className="mb-1 fw-semibold">{t("Indoor Use")}</h6>
                          <small className="text-muted">{t("Indoor Use Description")}</small>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-12">
                      <div className="d-flex align-items-center p-3 rounded-3 border-start border-4" 
                           style={{backgroundColor: '#f8f9fa', borderColor: '#6c757d'}}>
                        <div className="me-3">
                          <i className="fas fa-building" style={{color: '#6c757d', fontSize: '1.2rem'}}></i>
                        </div>
                        <div>
                          <h6 className="mb-1 fw-semibold">{t("Outdoor Use")}</h6>
                          <small className="text-muted">{t("Outdoor Use Description")}</small>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-12">
                      <div className="d-flex align-items-center p-3 rounded-3 border-start border-4" 
                           style={{backgroundColor: '#f8f9fa', borderColor: '#a79682'}}>
                        <div className="me-3">
                          <i className="fas fa-city" style={{color: '#a79682', fontSize: '1.2rem'}}></i>
                        </div>
                        <div>
                          <h6 className="mb-1 fw-semibold">{t("Architecture")}</h6>
                          <small className="text-muted">{t("Architecture Description")}</small>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-12">
                      <div className="d-flex align-items-center p-3 rounded-3 border-start border-4" 
                           style={{backgroundColor: '#f8f9fa', borderColor: '#6c757d'}}>
                        <div className="me-3">
                          <i className="fas fa-couch" style={{color: '#6c757d', fontSize: '1.2rem'}}></i>
                        </div>
                        <div>
                          <h6 className="mb-1 fw-semibold">{t("Furniture")}</h6>
                          <small className="text-muted">{t("Furniture Description")}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Available Formats */}
                <div className="mb-4">
                  <h5 className="fw-bold mb-3" style={{color: '#333'}}>
                    <i className="fas fa-th-large me-2" style={{color: '#a79682'}}></i>
                    {t("Available Formats")}
                  </h5>
                  <p className="text-muted mb-3">{t("Available Formats Description")}</p>
                  
                  <div className="row g-3">
                    <div className="col-6">
                      <div className="text-center p-3 rounded-3 border h-100" 
                           style={{backgroundColor: '#f8f9fa'}}>
                        <i className="fas fa-cube mb-2" style={{fontSize: '2rem', color: '#a79682'}}></i>
                        <h6 className="fw-semibold mb-1">{t("Blocks")}</h6>
                        <small className="text-muted">{t("Blocks Description")}</small>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="text-center p-3 rounded-3 border h-100" 
                           style={{backgroundColor: '#f8f9fa'}}>
                        <i className="fas fa-square mb-2" style={{fontSize: '2rem', color: '#6c757d'}}></i>
                        <h6 className="fw-semibold mb-1">{t("Slabs")}</h6>
                        <small className="text-muted">{t("Slabs Description")}</small>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Contact Buttons */}
                <div className="row g-2">
                  <div className="col-12">
                    <Link 
                      to="/iletisim" 
                      className="btn btn-lg rounded-pill py-3 w-100"
                      style={{backgroundColor: '#a79682', borderColor: '#a79682', color: 'white'}}
                      onClick={scrollToTop}
                    >
                      <i className="fas fa-envelope me-2"></i>
                      {t("Get Quote")}
                    </Link>
                  </div>
                  <div className="col-12">
                    <a href="tel:+902242493435" 
                       className="btn btn-outline-secondary btn-lg rounded-pill py-3 w-100"
                       style={{borderColor: '#a79682', color: '#a79682'}}>
                      <i className="fas fa-phone me-2"></i>
                      (+90) 224 249 34 35
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ElmaliCosmosBeige;